module.exports = __webpack_public_path__ + "25a7f4b58d150b212ba387d7df93c143.png";